import styled from 'styled-components';
import { DemoVehicleLabelStyled } from '../DemoVehicleLabelStyled';
import { rem } from 'polished';

export const DemoVehicleLabelStyledAP = styled(DemoVehicleLabelStyled)`
    .info {
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-size: ${({ theme }) => theme.fontSizes.textSmall};

        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }

    .details {
        color: ${({ theme }) => theme.colors.grey17};
        font-size: ${({ theme }) => theme.fontSizes.textTiny};

        &-label {
            color: ${({ theme }) => theme.colors.black};
        }
    }
`;
